<template>
  <div class="sales-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              sales

              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'salesDetails' })"
              >
                Sales Details
              </button>
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'productsPromotionDetails' })"
              >
                Promotions Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="summary-list row row-cols-7">
        <div :key="data.id" class="col" v-for="data in weekData">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                Day {{ data.day }}/{{ data.month }}
                <small>Week {{ data.week_num }}</small>
              </h3>

              <div class="figure">
                {{ data.number }}
                <small>Packs</small>
                <!-- <small>/ RP {{ data.number }}</small> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
              <div class="card data-card">
                <div class="row data-card-header">
                  <div class="col-md-6">
                    <h3 class="card-heading">
                      Sales By Area
                    </h3>
                  </div>
                  <div class="col-md-6 text-md-right">
                    <select
                      class="custom-select form-control"
                      @change="getSalesSummaryByArea"
                      v-model="areaDateDropdown"
                    >
                      <option
                        :key="index"
                        v-for="(data, index) in weeklyDateFilter"
                        :value="data.date"
                      >
                        {{ data.text }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-12 col-sm-6">
                    <h4 class="section-title">Top 5</h4>

                    <dl
                      :key="data.id"
                      class="row no-gutters"
                      v-for="(data, index) in areaTopFiveData"
                    >
                      <dt class="col-1">
                        {{ (index += 1) }}.
                      </dt>
                      <dt class="col-7">
                        {{ data.name }}
                      </dt>
                      <dd class="col-4">
                        {{ data.number }}
                      </dd>
                    </dl>
                  </div>
                  <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                    <h4 class="section-title">Least 5</h4>

                    <dl
                      :key="data.id"
                      class="row no-gutters"
                      v-for="(data, index) in areaLeastFiveData"
                    >
                      <dt class="col-1">
                        {{ (index += 1) }}.
                      </dt>
                      <dt class="col-7">
                        {{ data.name }}
                      </dt>
                      <dd class="col-4">
                        {{ data.number }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card data-card">
                <div class="row data-card-header">
                  <div class="col-md-6">
                    <h3 class="card-heading">
                      Sales By Sku
                    </h3>
                  </div>
                  <div class="col-md-6 text-md-right">
                    <select
                      class="custom-select form-control"
                      @change="getSalesSummaryBySku"
                      v-model="skuDateDropdown"
                    >
                      <option
                        :key="index"
                        v-for="(data, index) in weeklyDateFilter"
                        :value="data.date"
                      >
                        {{ data.text }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-lg-12 col-sm-6">
                    <h4 class="section-title">Top 10</h4>

                    <dl
                      :key="data.id"
                      class="row no-gutters"
                      v-for="(data, index) in skuTopData.slice(0, 5)"
                    >
                      <dt class="col-1">
                        {{ (index += 1) }}.
                      </dt>
                      <dt class="col-7">
                        {{ data.sku.name }}
                      </dt>
                      <dd class="col-4">
                        {{ data.number }}
                      </dd>
                    </dl>
                  </div>
                  <div v-if="skuTopData.count > 5" class="col-xl-6 col-lg-12 col-sm-6">
                    <dl
                      :key="data.id"
                      class="row no-gutters"
                      v-for="(data, index) in skuTopData.slice(5, 10)"
                    >
                      <dt class="col-1">
                        {{ (index += 6) }}.
                      </dt>
                      <dt class="col-7">
                        {{ data.sku.name }}
                      </dt>
                      <dd class="col-4">
                        {{ data.number }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col">
              <div class="card data-card">
                <div class="row data-card-header">
                  <div class="col-md-6">
                    <h3 class="card-heading">
                      Total Sales
                    </h3>
                  </div>
                  <div class="col-md-6 text-md-right">
                    <select
                      class="custom-select form-control"
                      @change="getSalesChart"
                      v-model="salesChartDateDropdown"
                    >
                      <option value="year">YEAR</option>
                      <option value="month">MONTH</option>
                      <option value="week">WEEK</option>
                    </select>
                  </div>
                </div>
                <app-line-chart
                  :chart-data="salesChartData"
                  :options="chartOption"
                  :height="250"
                ></app-line-chart>
              </div>
            </div>
      </div>

      <app-loader v-show="isLoading"></app-loader>
    </div>
  </div>
</template>

<style scoped>
.sales-summary .top-navbar .top-navbar-right button:first-child {
  margin-right: 20px;
}
</style>

<script>
import {
  checkPermission,
  getDashboardDate,
  getSalesSummaryByType,
  getSalesSummaryByCategory
} from "../api";
import { getProj } from "../helpers";
import Loader from "./Loader";
import LineChart from "./chart/LineChart.vue";

export default {
  components: {
    appLoader: Loader,
    appLineChart: LineChart
  },
  data() {
    const moment = require("moment");
    const thisMonday = moment()
      .day("Monday")
      .format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      restrictViewUsers: false,
      isLoading: true,
      projectId: getProj()["projId"],
      weeklyDateFilter: [],
      weekData: "",
      areaTopFiveData: "",
      areaLeastFiveData: "",
      areaDateDropdown: thisMonday,
      skuTopData: "",
      skuDateDropdown: thisMonday,
      chartOption: JSON.parse(process.env.VUE_APP_CHART),
      salesChartDateDropdown: "month",
      salesChartData: {}
    };
  },
  async mounted() {
    this.restrictViewUsers = await this.checkPermission("restrict users");
    await this.getDate();
    await this.getSalesSummaryByDay();
    await this.getSalesSummaryByArea();
    await this.getSalesSummaryBySku();
    await this.getSalesChart();

    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const weekParams = { dateType: "week" };
        const result = await getDashboardDate(weekParams);
        this.weeklyDateFilter = result.data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async checkPermission(permission) {
      try {
        const result = await checkPermission({ permission: permission });
        return result.data.data;
      } catch (err) {
        return false;
      }
    },
    async getSalesSummaryByDay() {
      try {
        let result = await getSalesSummaryByType({
          projectId: this.projectId,
          dateType: "day"
        });

        this.weekData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getSalesSummaryByArea() {
      try {
        let result = await getSalesSummaryByCategory({
          projectId: this.projectId,
          category: "area",
          date: this.areaDateDropdown
        });

        this.areaTopFiveData = result.data.data.statistics.topfive;
        this.areaLeastFiveData = result.data.data.statistics.worstFive;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getSalesSummaryBySku() {
      try {
        let result = await getSalesSummaryByCategory({
          projectId: this.projectId,
          category: "sku",
          date: this.skuDateDropdown
        });

        this.skuTopData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getSalesChart() {
      try {
        let result = await getSalesSummaryByType({
          projectId: this.projectId,
          dateType: this.salesChartDateDropdown
        });

        this.salesChartData = result.data.data.statistics;
        this.filterPromoChart();
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    filterPromoChart() {
      let labels = [];
      let data = [];

      this.salesChartData.forEach(item => {
        if (this.salesChartDateDropdown == "week")
          labels.push(`WEEK ${item.week_num}`);
        if (this.salesChartDateDropdown == "month") labels.push(item.month);
        if (this.salesChartDateDropdown == "year") labels.push(item.year);
        data.push(item.number);
      });

      this.salesChartData = {
        labels: labels,
        datasets: [
          {
            label: "Total CDC",
            backgroundColor: "rgba(0, 0, 0, 0)",
            borderColor: "#FDCD08",
            borderWidth: 2,
            lineTension: 0,
            data: data
          }
        ]
      };
    }
  }
};
</script>
